import store from "@/store";
let siteSettings = store.getters.siteSettings;
let auth = store.getters.isAuthenticated;
const walletRoutes = ['Wallet', 'WalletDeposit', 'WalletWithdraw', 'WalletHistory', 'TransactionDetails', 'DepositPaymentMethod', 'WithdrawDetails', 'WithdrawAccountDetails'];

export const routerGuard = (to, from, next) => {
    try {
        const isDemoUser = store.getters?.stateUser?.isDemo;
        const underMaintenance = store.getters.underMaintenance;
        const isMaintenancePage = to.name === 'Maintenance';
        const modalInstance = document.querySelector('.modal.show')
        let isLandingPage = siteSettings?.is_landing_page;
        let lpRoutes = ['LandingPage', 'Login', 'SignUp', 'ForgotPassword'];
        
        if (underMaintenance) {
            if (!isMaintenancePage) {
                next({ name: 'Maintenance' });
            } else {
                next();
            }
        } else {
            if (isMaintenancePage) {
                next({ name: 'Home' });
            } else {
                if(modalInstance && modalInstance.id != 'success_submit'){
                    next(false);
                    return;
                }
                if (isDemoUser && walletRoutes.includes(to.name)) {
                    errorToast('Wallet Access Is Restricted For Demo User.');
                    next({ name: 'Home' });
                }
                if(siteSettings) {
                    if(isLandingPage && !auth && !lpRoutes.includes(to.name)) {
                        return next({name : 'LandingPage'});
                    } else if(auth && lpRoutes.includes(to.name)) {
                        return next({name : 'Home'});
                    } else if(isLandingPage && !auth && to.name == 'Home') {
                        return next({name : 'LandingPage'});
                    } else if(isLandingPage && !auth && lpRoutes.includes(to.name)) {
                        return next();
                    } else if(!isLandingPage && !auth && to.name == 'LandingPage') {
                        return next({name : 'Home'});
                    } else {
                        next();
                    }
                } else {
                    next();
                }
            }
        }
    } catch (e) {
        console.log(e);

    } 
    finally{
        setTimeout(()=>{
            window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        },500)
    }

};